import { render, staticRenderFns } from "./EngineeringBranchesList.vue?vue&type=template&id=4c04b0fb&"
import script from "./EngineeringBranchesList.vue?vue&type=script&lang=js&"
export * from "./EngineeringBranchesList.vue?vue&type=script&lang=js&"
import style0 from "./EngineeringBranchesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports